import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'
import './pixelRuntime'

// Ready signal comes from inside the snippet (via __sfMarkVendorReady, installed
// by pixelRuntime), not from <Script onReady>. Next.js fires onReady before an
// inline body executes, which would drain the queue while window.fbq is still
// undefined.
export const FacebookPixel: React.FC<{
    landingPage: ApiShopperLandingPage
    scriptsReady?: boolean
}> = ({ landingPage, scriptsReady = true }) => {
    const metaPixelId = landingPage.integrations.metaPixelId
    if (!metaPixelId || !scriptsReady) return null

    return (
        <Script
            id="facebook-pixel"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${metaPixelId}');
          fbq('track', 'PageView');
          window.__sfMarkVendorReady && window.__sfMarkVendorReady('meta');
        `,
            }}
        />
    )
}
